import React from "react"
import { graphql } from "gatsby"
import Hero from "../components/Hero"
import Info from '../components/Info';
import Services from "../components/Services"
import Projects from "../components/Projects"
import Applications from "../components/Applications"
import ContactSection from '../components/Contact'

import Seo from "../components/Seo"

const IndexPage = ({data}) => {
  const {
    allStrapiProject: { nodes: projects },
    allStrapiApp: { nodes: apps }, 
  } = data
  return (
    <>
     <Seo title="Home" />
   <main>
     <Hero />
     <Info />
     <Services />
     <Projects 
      showLink
      projects={projects} 	
      pretitle="My work" 
      className= "title-center" 
      title="Featured projects"
      subtitle="I'm always seeking new exciting projects to build-out my portfolio even further. " 
    />
   <Applications
      apps={apps} 	
      pretitle="My apps" 
      className= "title-left" 
      title="Featured applications"
      subtitle="I strive to build immersive and beautiful web applications through carefully crafted code and user-centric design." 
      showLink 
      /> 
 <ContactSection 
      />
   </main>
    </>
  )
}

export const query = graphql`
  {
    allStrapiProject(filter: { featured: { eq: true } }) {
      nodes {
        description
        featured
        github
        id
        slug
        title
        url
        stack {
          id
          title
        }
        image {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
          }
        }
      }
      totalCount
    }
    allStrapiApp(filter: { featured: { eq: true } }) {
      nodes {
        github
        id
        description
        title
        url
        image {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
          }
        }
        stack {
          id
          title
        }
      }
    } 
  }
`

export default IndexPage
